import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { _CLASSES_STORE } from '@/classes/values/classes.values';
import EdCreateComponentCourse from '@/course-templates/components/ed-create-component-course/ed-create-component-course.component.vue';
import EdSubjectComponentItem from '@/course-templates/components/ed-subject-component-item/ed-subject-component-item.component.vue';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { maxLength, required } from 'vuelidate/lib/validators';
import KEYS from '@/values/keys';
import { Mixins } from 'vue-property-decorator';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { SectionsProvider } from '@/content/providers/sections.provider';

@Component({
  name: 'ed-customize-components-course',
  components: {EdCreateComponentCourse, EdSubjectComponentItem}
})

export default class EdCustomizeComponentsCourse extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  loading: boolean = false;
  pagination: object = { current: 1, total: 0 };
  itemSelected: any = {};
  showCreateEduacComponent: boolean = false;
  paramsToEdit: any = {};
  hideElement: boolean = true;
  saving: boolean = false;
  form: any = null;
  

  @Emit('showParentForm')
  showParentForm(data) {
    return data;
  }

  get headers() {
    return [
        { text: this.$t('common.name'),  value: 'name', sortable: false },
        { text: this.$t('common.actions'), align: 'center', value: 'actions', sortable: false },
    ]
  }

  get components() {
    return this.getCourseFromStore({
      classId: this.params.classId,
      courseId: this.params.courseId
    }).eduacComponents;
  }

  createItem() {
    this.showCreateEduacComponent = true;
    this.paramsToEdit =
      {
        courseId: this.params.courseId, 
        classId: this.params.classId, 
        edit: false
      }
  }

  editItem(item) {
    this.showCreateEduacComponent = true;
    (this.$refs.name as Vue).$el.scrollIntoView();
    ((this.$refs.name as Vue).$el as HTMLInputElement).focus();
    this.paramsToEdit =
      {
        courseId: this.params.courseId, 
        classId: this.params.classId, 
        edit: true,
        data: item
      }
    this.form.name.value = item.name;
  }

  showDeleteModal(item) {
    this.$EdModal.createConfirmationModal({
      body: this.$t('courses.eduacComponents.deleteQuestion'), 
      onFront: true,
      type: KEYS.EVENT_TYPES.WARNING,
      actions: [
        {
          label : this.$t('common.cancel'),
          mode  : 'outline',
        },
        {
          label : this.$t('common.confirm'),
          action: this.deleteItem
        },
      ]
    })

    this.itemSelected = item;
  }

  async deleteItem() {
    await this.$Courses.Store.removeComponent({courseId: this.params.courseId, classId: this.params.classId, componentId: this.itemSelected.id});
    await this.getContentForCourse({ courseId: this.params.courseId });
    this.$edEventBus.$emit('updateSelected');
    this.refreshAndClose();
  }

  closeModal() {
    this.$EdModal.closeBootstrapModal();
  }

  init( name: string = '') {
    this.form = EdFormModel([
      EdInputModel('name', 
        name, {
        required,
        maxLength: maxLength(60)
      })
    ]);
  }

  showCustomizeEduacComponent(data) {
    this.showCreateEduacComponent = false;
  }

  async update() {
    try {
      let data = this.paramsToEdit.data;
      data.name = this.form.name.value;
      this.$Courses.Store.updateComponent({courseId: this.params.courseId, classId: this.params.classId, data: data});
      this.refreshAndClose();
    } catch(err) {
      this.saving = false;
      this.showErrorMessage();
    }
  }

  async create() {
    try {
      this.$Courses.Store.createComponent({courseId: this.params.courseId, classId: this.params.classId, data: {name : this.form.name.value, mandatory: false, entityId: this.params.courseId, entityType: 'CONTENT'}});
      this.refreshAndClose();
    } catch(err) {
      this.saving = false;
      this.showErrorMessage();
    }
  }
  
  refreshAndClose() {
    this.saving = false;
    this.paramsToEdit = {};
    this.form.name.value = '';
    this.init();
  }

  showErrorMessage() {
    let body = this.$i18n.t('courses.eduacComponents.errorSaving');
    this.$EdModal.createMessageModal({
      body,
      title: this.$i18n.t('courses.eduacComponents.errorSavingTitle'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  save() {
    this.saving = true;
    if (this.paramsToEdit.edit) {
      this.update();
    } else {
      this.create();
    }
  }

  created() {
    this.init();
  }

  @Watch('form.name.value')
  onNameChange(val: string) {
    if (val.length === 0) {
      this.paramsToEdit = {};
    }
  }
}